module.exports = __webpack_public_path__ + "static/media/arrowone.ef21ab03.svg";